import { render, staticRenderFns } from "./orderHistoryProductsModal.vue?vue&type=template&id=24efb7c3&"
import script from "./orderHistoryProductsModal.vue?vue&type=script&lang=js&"
export * from "./orderHistoryProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports